<template>
  <div class="container" v-if="visible">
    <!--    <div-->
    <!--      class="top_header"-->
    <!--      :style="{-->
    <!--        background:-->
    <!--          scrollTop > 50-->
    <!--            ? '#fff'-->
    <!--            : 'linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(84,84,84,0) 100%)',-->
    <!--      }"-->
    <!--    >-->
    <!--      <van-icon-->
    <!--        class="top_backicon"-->
    <!--   style="color:#1989fa"-->
    <!--        type="arrow-left"-->
    <!--        size="30"-->
    <!--      ></van-icon>-->
    <!--      <div class="top_header_right">-->
    <!--        <div @click.stop="handleTopoperateShow">-->
    <!--          <van-icon-->
    <!--            type="more-filled"-->
    <!--            size="30"-->
    <!--            :color="scrollTop > 50 ? '#000' : '#fff'"-->
    <!--          ></van-icon>-->
    <!--        </div>-->
    <!--        <div class="top_header_right_item" v-if="topoperateShow">-->
    <!--          <div class="top_header_right_item_item" @click="handleShare">-->
    <!--            分享-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="banner-container">
      <!--      活动标题图-->
      <img :src="posterDetail.bgImgTitle" />
    </div>
    <!--    视频-->
    <!--    <div class="video-container" v-if="posterDetail.enableUlVideo === 1">-->
    <!--      <d-player :url="posterDetail.videoUrl" />-->
    <!--    </div>-->
    <!--    预约背景-->
    <div v-if="posterDetail.withRetention" class="save-info-container">
      <discounted-buy-car
        class="custom-buy-car"
        @appointment="handleAppointment"
        :background-image="posterDetail.bgImgPre"
        :acti-large-post-id="posterDetail.id"
        :type="posterDetail.relType"
        :activity-source="posterDetail.actiName"
      />
    </div>
    <div class="lottery-container">
      <lottery
        :phone="phone"
        :user-name="name"
        :appType="appType"
        :title-image="posterDetail.bttTitleImg"
        :background-image="posterDetail.bttBgImg"
        :list="lotteryDetail.labg"
        :actiBigturntableId="lotteryDetail.id"
        :enableBtt="posterDetail.enableBtt"
        :acti-large-post-id="posterDetail.id"
      />
    </div>
    <div
      class="banner-container"
      :class="posterDetail.redirectImgPosition ? '' : 'padding-container'"
    >
      <!-- 活动背景图片-->
      <img :src="posterDetail.bgBgImg" />
    </div>
    <div
      v-if="posterDetail.redirectImgUrl"
      :class="posterDetail.redirectImgPosition ? 'box-float' : 'box-footer'"
      @click="entryAdvert(posterDetail.redirectUrl)"
    >
      <img :src="posterDetail.redirectImgUrl" class="advert-img" />
    </div>
    <van-dialog
      v-model="isShowDialog"
      @confirm="onConfirm"
      :title="activityFilter(activityState)"
    >
    </van-dialog>
  </div>
</template>

<script>
import DiscountedBuyCar from '@/components/DiscountedBuyCar.vue'
import Lottery from '@/components/Lottery.vue'
import DPlayer from '@/components/DPlayer.vue'
import { getPosterConfig, getWxConfig } from '@/api'
import { Dialog } from 'vant'
import { initWx } from '@/utils/jssdk'

export default {
  name: 'index',
  components: { DiscountedBuyCar, Lottery },
  data() {
    return {
      // topoperateShow: false,
      // sharePopup: null,
      // scrollTop: 0,
      isShowDialog: false,
      activityState: '', // 当前活动的状态
      phone: '',
      name: '',
      appType: '',
      posterDetail: {
        bgImgTitle: '',
        enableUlVideo: 0,
        videoUrl: '',
        bgImgPre: '',
        enableBtt: 1,
        bttTitleImg: '',
        withRetention: 1
      },
      lotteryDetail: {},
      visible: true
    }
  },
  created() {
    const { id } = this.$route.query
    if (id) {
      getPosterConfig({ id })
        .then((res) => {
          this.posterDetail = res.data
          this.lotteryDetail = res.data.actiBigturntableDetailVO
          if (res.data.actiState && res.data.actiState !== 'GOING') {
            this.activityState = res.data.actiState
            this.isShowDialog = true
          }
        })
        .then(() => getWxConfig({ url: window.location.href.split('#')[0] }))
        .then((res) => initWx(res.data))
        .then(() => {
          // eslint-disable-next-line no-undef
          wx.ready(() => {
            const content = {
              title: this.posterDetail.shareTitle,
              desc: this.posterDetail.shareDoc,
              link: window.location.href,
              imgUrl: this.posterDetail.actThumbnail,
              success: () => {}
            }
            // eslint-disable-next-line no-undef
            wx.updateTimelineShareData(content)
            // eslint-disable-next-line no-undef
            wx.updateAppMessageShareData(content)
          })
        })
        .catch((err) => {
          console.error(err.message)
        })
    } else {
      Dialog.alert({
        title: '警告',
        message: '需要活动id'
      }).then(() => {
        this.visible = false
      })
    }
  },
  methods: {
    // handleTopoperateShow() {
    //   this.topoperateShow = !this.topoperateShow
    // },
    // handleTopoperateHide() {
    //   this.topoperateShow = false
    // },
    // handleShare() {
    //   if (this.isLogin()) {
    //     this.$refs.sharePopup.open()
    //   }
    // },
    // async handleShareTo(e) {
    //   try {
    //     // 分享到微信
    //     if (this.IS_APP) {
    //       const sendMessage = {
    //         shareType: e.item.name === "WXSceneSession" ? "0" : "1", // 类型 0：微信好友 1：朋友圈
    //         url: "http://jacwxmp.starnetah.com:9201/pages/market/preferential/index", // 网页url
    //         summary: "", // 网页描述
    //         imageUrl: "", // 位图
    //         title: "优惠买车", // 网页标题
    //       };
    //
    //       if (uni.getSystemInfoSync().platform === "android") {
    //         window.Android.sharePost(JSON.stringify(sendMessage));
    //       } else {
    //         window.webkit.messageHandlers.sharePost.postMessage(sendMessage);
    //       }
    //     }
    //   } catch (error) {
    //     console.error("生成图片失败:", error);
    //   }
    // },
    // onPageScroll(e) {
    //   this.scrollTop = e.scrollTop;
    // },
    activityFilter(state) {
      if (state === 'SHUT_DN') {
        return '活动已关闭'
      }
      if (state === 'END') {
        return '活动已结束'
      }
      if (state === 'NOT_ST') {
        return '活动未开始'
      }
      return '活动已关闭'
    },
    // 弹窗确认回调函数
    onConfirm() {
      this.isShowDialog = false
      // 判断是否在uni-app环境中
      if (window.uni && typeof window.uni.navigateBack === 'function') {
        // 在uni-app环境中，返回上一页
        window.uni.navigateBack()
      } else if (window.history && window.history.length > 1) {
        // 在普通H5环境中，使用浏览器返回
        window.history.back()
      } else {
        // 备用方案：跳转到首页
        this.$router.push('/pages/home/index')
      }
    },
    handleAppointment(val) {
      const { phone, name } = val
      this.phone = phone
      this.name = name
    },
    entryAdvert(redirectUrl) {
      if (redirectUrl) {
        window.location.href = redirectUrl
      }
    }
  }
}
</script>

<style scoped lang="scss">
.custom-buy-car ::v-deep img {
  height: 550px !important;
}

img {
  display: block;
  width: 100%;
}
.padding-container {
  // padding-bottom: rem(120);
  padding-bottom: 0;
}
.box-float {
  position: fixed;
  top: 50%;
  right: rem(10);
  width: rem(120);
  height: rem(120);
  margin-top: rem(-60);
  .advert-img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
}
.box-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: rem(120);
  .advert-img {
    width: 100%;
    height: 100%;
  }
}
</style>
